// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ShZ5","footer":"ModalFilter_footer__kVoaj"};